var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 17.28,
    height: 14.4,
    transform: "translate(345.883 374.8)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Wallet_Icon_Grey_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallet_Icon_Grey_2",
    "data-name": "Wallet Icon Grey \\u2013 2",
    clipPath: "url(#clip-Wallet_Icon_Grey_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3871",
    "data-name": "Group 3871",
    transform: "translate(-345.882 -372.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3870",
    "data-name": "Group 3870",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3857",
    "data-name": "Group 3857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6304",
    "data-name": "Path 6304",
    d: "M360.959,383.821h-2.852a1.822,1.822,0,1,1,0-3.643h2.852a1.822,1.822,0,1,1,0,3.643Zm-2.852-2.843a1.021,1.021,0,0,0,0,2.043h2.852a1.021,1.021,0,0,0,0-2.043Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6027",
    "data-name": "Path 6027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3858",
    "data-name": "Group 3858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6305",
    "data-name": "Path 6305",
    d: "M360.189,388.621H348.126a1.863,1.863,0,0,1-1.861-1.86v-9.522a1.863,1.863,0,0,1,1.861-1.861h12.063a1.864,1.864,0,0,1,1.862,1.861v3.339a.4.4,0,0,1-.8,0v-3.339a1.062,1.062,0,0,0-1.061-1.061H348.126a1.062,1.062,0,0,0-1.061,1.061v9.522a1.062,1.062,0,0,0,1.061,1.06h12.063a1.062,1.062,0,0,0,1.061-1.06v-3.34a.4.4,0,0,1,.8,0v3.34A1.863,1.863,0,0,1,360.189,388.621Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6028",
    "data-name": "Path 6028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3859",
    "data-name": "Group 3859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6306",
    "data-name": "Path 6306",
    d: "M358.613,388.622a.4.4,0,0,1,0-.8,1.061,1.061,0,0,0,1.061-1.06v-3.339a.4.4,0,0,1,.8,0v3.339A1.863,1.863,0,0,1,358.613,388.622Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6029",
    "data-name": "Path 6029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3860",
    "data-name": "Group 3860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6307",
    "data-name": "Path 6307",
    d: "M360.074,380.978a.4.4,0,0,1-.4-.4v-3.339a1.062,1.062,0,0,0-1.061-1.061.4.4,0,0,1,0-.8,1.864,1.864,0,0,1,1.862,1.861v3.339A.4.4,0,0,1,360.074,380.978Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6030",
    "data-name": "Path 6030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3861",
    "data-name": "Group 3861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6308",
    "data-name": "Path 6308",
    d: "M358.213,383.033A1.033,1.033,0,1,1,359.247,382,1.035,1.035,0,0,1,358.213,383.033Zm0-1.267a.234.234,0,0,0-.233.234c0,.257.466.255.466,0A.233.233,0,0,0,358.213,381.766Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_661",
    "data-name": "Line 661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3862",
    "data-name": "Group 3862"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 0.801,
    height: 0.458,
    transform: "translate(348.188 377.133)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_662",
    "data-name": "Line 662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3863",
    "data-name": "Group 3863"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 0.801,
    height: 0.458,
    transform: "translate(348.188 378.679)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_663",
    "data-name": "Line 663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3864",
    "data-name": "Group 3864"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 0.801,
    height: 0.458,
    transform: "translate(348.188 380.225)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_664",
    "data-name": "Line 664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3865",
    "data-name": "Group 3865"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 0.801,
    height: 0.458,
    transform: "translate(348.188 381.771)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_665",
    "data-name": "Line 665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3866",
    "data-name": "Group 3866"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 0.801,
    height: 0.458,
    transform: "translate(348.188 383.317)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_666",
    "data-name": "Line 666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3867",
    "data-name": "Group 3867"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 0.801,
    height: 0.458,
    transform: "translate(348.188 384.863)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_667",
    "data-name": "Line 667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3868",
    "data-name": "Group 3868"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 0.801,
    height: 0.458,
    transform: "translate(348.188 386.409)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6031",
    "data-name": "Path 6031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3869",
    "data-name": "Group 3869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6309",
    "data-name": "Path 6309",
    d: "M352.692,384.481a2.012,2.012,0,0,1-.393-.072,1.824,1.824,0,0,1-.33-.109l.006-.609a2.965,2.965,0,0,0,.462.14,2.172,2.172,0,0,0,.514.064.891.891,0,0,0,.619-.21.689.689,0,0,0,.234-.537.9.9,0,0,0-.068-.36.658.658,0,0,0-.184-.255,2.933,2.933,0,0,0-.531-.288l-.389-.181a1.55,1.55,0,0,1-.69-.546,1.413,1.413,0,0,1-.2-.761,1.194,1.194,0,0,1,.288-.8,1.232,1.232,0,0,1,.657-.4l0-.552h.629v.517a1.472,1.472,0,0,1,.706.2v.614a1.488,1.488,0,0,0-.4-.184,1.61,1.61,0,0,0-.5-.089.721.721,0,0,0-.528.191.657.657,0,0,0-.193.49.793.793,0,0,0,.072.336.711.711,0,0,0,.2.257,2.869,2.869,0,0,0,.5.283l.3.144a1.8,1.8,0,0,1,.751.587,1.548,1.548,0,0,1,.237.891,1.114,1.114,0,0,1-.317.786,1.316,1.316,0,0,1-.814.413V385H352.7Z",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletWhite);
export default __webpack_public_path__ + "static/media/walletWhite.66668810e80e329fe49d994b32723f8e.svg";
export { ForwardRef as ReactComponent };